import { useState } from "react"
import { Category } from "./categories-section/Category"
import {
    cameraActive, camera, computer, computerActive, smartwatch,
    smartwatchActive, cellphone, cellphoneActive, headphone,
    headphoneActive, gamepad, gamepadActive
} from "./categories-section/CategoriesIcons"
import { ScrollArrows } from "./ScrollArrows"
import { SectionTitle } from "../global/SectionTitle"
import "./categoriesSection.css"

export function CategoriesSection() {
    const [activeCategory, setActiveCategory] = useState(null)

    const categories = [
        {
            title: "Phones",
            icon: cellphone,
            hoverIcon: cellphoneActive,
        },
        {
            title: "Computers",
            icon: computer,
            hoverIcon: computerActive,
        },
        {
            title: "SmartWatch",
            icon: smartwatch,
            hoverIcon: smartwatchActive,
        },
        {
            title: "Camera",
            icon: camera,
            hoverIcon: cameraActive,
        },
        {
            title: "Headphones",
            icon: headphone,
            hoverIcon: headphoneActive,
        },
        {
            title: "Gaming",
            icon: gamepad,
            hoverIcon: gamepadActive,
        },
    ]

    function toggleCategory(category) {
        if (activeCategory === category) {
            setActiveCategory(null)
        } else {
            setActiveCategory(category)
        }
    }

    return (
        <div className="categories-section">
            <SectionTitle title="Categories" />

            <div className="d-flex justify-content-between my-3">
                <p className="section-title">Browse By Category</p>
                <div className="scroll-arrows lg-on">
                    <ScrollArrows />
                </div>

            </div>

            <div className="categories-slide d-flex">

                {
                    categories.map((e, i) =>
                        <Category
                            key={i}
                            title={e.title}
                            icon={e.icon}
                            hoverIcon={e.hoverIcon}
                            activeCategory={activeCategory}
                            toggleCategory={toggleCategory}
                        />
                    )
                }

            </div>
            <hr />
        </div>
    )
}